var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"notification-setting-block"},[_c('div',{staticClass:"subtitle-2 my-1"},[_vm._v(" "+_vm._s(_vm.props.title)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }